import React, { useState, useEffect, useMemo } from 'react';
import { Phone, X, Sparkles } from 'lucide-react';

const FloatingCTA = ({ onOpenModal }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  // Dynamic month and spots calculation
  const { currentMonth, spotsLeft } = useMemo(() => {
    const now = new Date();
    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 
                        'July', 'August', 'September', 'October', 'November', 'December'];
    // Get next month for "onboarding" context
    const nextMonthIndex = (now.getMonth() + 1) % 12;
    const month = monthNames[nextMonthIndex];
    
    // Generate pseudo-random spots (2-5) based on day of month to seem dynamic but consistent per day
    const dayOfMonth = now.getDate();
    const spots = ((dayOfMonth * 7) % 4) + 2; // Results in 2, 3, 4, or 5
    
    return { currentMonth: month, spotsLeft: spots };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 600 && !isDismissed) {
        setIsVisible(true);
      } else if (window.scrollY <= 600) {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isDismissed]);

  if (!isVisible || isDismissed) return null;

  return (
    <div className="fixed bottom-24 right-6 z-40 animate-in slide-in-from-right duration-500">
      <div className="relative bg-gradient-to-r from-purple-600 to-purple-700 rounded-2xl p-4 shadow-2xl shadow-purple-500/30 max-w-xs">
        <button
          onClick={() => setIsDismissed(true)}
          className="absolute -top-2 -right-2 w-6 h-6 bg-gray-800 rounded-full flex items-center justify-center text-gray-400 hover:text-white"
        >
          <X className="w-4 h-4" />
        </button>
        
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0">
            <Sparkles className="w-5 h-5 text-white" />
          </div>
          <div>
            <p className="text-white font-medium text-sm mb-1">Limited Spots!</p>
            <p className="text-purple-100 text-xs mb-3">Only {spotsLeft} slots left for {currentMonth} onboarding</p>
            <button
              onClick={onOpenModal}
              className="flex items-center gap-2 bg-white text-purple-700 px-4 py-2 rounded-lg text-sm font-medium hover:bg-purple-50 transition-colors"
            >
              <Phone className="w-4 h-4" />
              Claim Your Spot
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FloatingCTA;
